// extracted by mini-css-extract-plugin
module.exports = {"root":"groupCreate_root__2YHUY","field":"groupCreate_field__-o77u","actionField":"groupCreate_actionField__2QWYy"};